// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3yIaa","content":"LayoutSettings_content__7gJsM"};